export const acervoPessoalTypes = {
  armasPessoa: [
    {
      anexos: [],
      documents: [],
    },
  ],
  ufs: [],
  finalidades: [],
  documentTypes: [],
}
